import { cn } from "@/lib/utils";

interface ScrollHintProps {
  show: boolean;
  className?: string;
  label?: string;
}

export const ScrollHint = ({ show, className, label = "Swipe" }: ScrollHintProps) => {
  if (!show) return null;

  return (
    <div className={cn(
      "flex items-center gap-3 text-muted-foreground transition-opacity duration-500",
      className
    )}>
      <span className="text-xs font-medium uppercase tracking-wider">{label}</span>
      <div className="flex items-center gap-1">
        <div className="w-1 h-1 rounded-full bg-primary/40" />
        <div className="w-1.5 h-1.5 rounded-full bg-primary/60" />
        <div className="w-2 h-2 rounded-full bg-primary animate-pulse" />
      </div>
    </div>
  );
};
